import React from 'react';


export function About() {
  return (
    <>
      <h2>[About]</h2>
    </>
  );
}
